class MultiVideos{
  constructor() {
    this.videosTriggers = document.querySelectorAll('[data-modal-video]');
    if(this.videosTriggers.length > 0) this.videoModelsOpener();
  }

  videoModelsOpener = () => {
    this.videosTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.stopImmediatePropagation();
        var iframeHTML = e.currentTarget.querySelector('iframe')?.outerHTML;
        var popupBody = document.querySelector('#Youtube-Drawer');
        if (popupBody != null) {
          iframeHTML = iframeHTML.replaceAll('iframe data-src', 'iframe src');
          iframeHTML = iframeHTML.replaceAll('height="auto"', 'height="500px"');
          iframeHTML = iframeHTML.replaceAll('autoplay=0&muted=1', 'autoplay=1&muted=1');
          iframeHTML = iframeHTML.replaceAll('autoplay=0&amp;muted=1', 'autoplay=1&amp;muted=1');
          iframeHTML = iframeHTML.replaceAll('d-none', '');
          popupBody.querySelector('#Youtube-Drawer-Content').innerHTML = iframeHTML;
          popupBody.classList.add('active');
          document.body.classList.add('open-cc--product');
        }
      })
    })
  }
}
new MultiVideos;